import { IconButton } from "@chakra-ui/react";
import { ArrowDropDown, ArrowDropDownOutlined, ArrowDropUp } from "@mui/icons-material";

const ControlArrows = ({columnName, sortColumn, setSortColumn, sortDirection, setSortDirection}) => {
    if (sortColumn !== columnName) {
        return (
            <IconButton
                sx={{padding:0, bgColor: "transparent", "&:hover":{backgroundColor: "transparent"}}}
            >
                <ArrowDropDownOutlined
                    sx={{ fontSize: 24, color: "#5d5d5d", bgColor: "transparent" }}
                    onClick={() => {
                        setSortDirection("asc");
                        setSortColumn(columnName);
                    }}
                />
            </IconButton>
        );
    }

    if (sortColumn === columnName && sortDirection === "asc") {
        return (
            <IconButton
                sx={{padding:0, bgColor: "transparent", "&:hover":{backgroundColor: "transparent"}}}
            >
                <ArrowDropUp
                    sx={{ fontSize: 24, color: "#5d5d5d", bgColor: "transparent" }}
                    onClick={() => {
                        setSortDirection("desc");
                        setSortColumn(columnName);
                    }}
                />
            </IconButton>
        );
    }

    if (sortColumn === columnName && sortDirection === "desc") {
        return (
            <IconButton
                sx={{padding:0, bgColor: "transparent", "&:hover":{backgroundColor: "transparent"}}}
            >
                <ArrowDropDown
                    sx={{ fontSize: 24, color: "#5d5d5d", bgColor: "transparent" }}
                    onClick={() => {
                        setSortDirection("asc");
                        setSortColumn(columnName);
                    }}
                />
            </IconButton>
        );
    }
}

export default ControlArrows;